// extracted by mini-css-extract-plugin
module.exports = {"event":"SchedulerEvent_event__18yR7"};